import React, { useState } from "react";
import { BsArrowRight } from "react-icons/bs";
import PageTitle from "../../../components/partials/PageTitle";
import PolicyScheduleDoc from "../../../components/policy/PolicyScheduleDoc";
import { BiArrowBack, BiCaretLeft, BiCaretRight } from "react-icons/bi";
import PolicyWording from "../../../components/policy/PolicyWording";
import { useSelector } from "react-redux";
import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { GenericPdfDownloader } from "../../../utils/helpers/functions";
import { Link, useLocation, useNavigate } from "react-router-dom";

const PolicySchedule = () => {
  const { policyScheduleData } = useSelector((state) => state.underwriting);
  const { user } = useSelector((state) => state.auth.user);
  const [activePage, setActivePage] = useState("schedule");

  const breadcrumb = {
    from: {
      title: "policy schedule",
      link: "/admin/customer-policy-view/policy-schedule",
    },
    current: {
      title: "policy schedule",
      link: null,
    },
  };

  const schedule = useRef();
  const { state } = useLocation();
  const navigate = useNavigate();

  // print schedule document to pdf
  const generatePDF = useReactToPrint({
    content: () => schedule.current,
    documentTitle: `${
      activePage === "schedule" ? "Schedule" : "Policy Wording"
    }`,
  });

  return (
    <>
      {/* page title */}
      <PageTitle
        title='Policy Schedule'
        breadcrumb={breadcrumb}
        back={state === "policy-history" ? true : false}
      />
      {/* end page title */}
      <div className='card'>
        <div className='card-body'>
          <div className='d-flex justify-content-between mb-4'>
            <span className='text-uppercase text-primary p-0 fw-bold'>
              Policy Document
            </span>
            <button
              type='button'
              className='btn btn-sm btn-primary d-flex align-items-center'
              onClick={() => navigate(-1)}
            >
              <BiArrowBack />
              <span>Back</span>
            </button>
          </div>
          <div ref={schedule} id='schedule'>
            <PolicyScheduleDoc
              data={policyScheduleData?.policy_document1}
              policy_document_risk={policyScheduleData?.policy_document_risk}
            />
            {policyScheduleData?.clauses?.length ? (
              <PolicyWording clauses={policyScheduleData?.clauses} />
            ) : null}
            <div className='d-flex justify-content-between mt-5'>
              <div
                style={{ width: "350px" }}
                className='d-grid place-items-center '
              >
                <div style={{ height: "50px", width: "80px" }} className=''>
                  {policyScheduleData?.policy_document1
                    ?.underwriter_signature && (
                    <img
                      src={
                        policyScheduleData?.policy_document1
                          ?.underwriter_signature
                      }
                      alt='underwriter_signature'
                      className='w-100'
                    />
                  )}
                </div>
                <div className='border-top border-dotted pt-2'>
                  <span className=' fw-bold text-center'>
                    {user.first_name + " " + user.last_name}
                  </span>
                  <span className=''>(Signature)</span>
                </div>
              </div>
              <div
                style={{ width: "350px" }}
                className='d-grid place-items-center '
              >
                <div
                  style={{ height: "50px", width: "80px", paddingLeft: "20px" }}
                  className=''
                >
                  {policyScheduleData?.policy_document1?.customer_signature && (
                    <img
                      src={
                        policyScheduleData?.policy_document1?.customer_signature
                      }
                      alt='customer_signature'
                      className='w-100'
                    />
                  )}
                </div>
                <div className='border-top border-dotted pt-2'>
                  <span className=' fw-bold '>For</span>
                </div>
              </div>
            </div>
          </div>

          <div className='d-flex gap-2 justify-content-end mt-4 mb-2'>
            <button
              type='button'
              className='btn btn-sm btn-primary text-center'
              onClick={() => {
                generatePDF();
              }}
            >
              Print
            </button>
            <GenericPdfDownloader
              rootElementId={"schedule"}
              downloadFileName={`${
                activePage === "schedule" ? "Schedule" : "Policy Wording"
              }`}
            />
            <button
              className='btn btn-sm btn-success d-flex gap-1 align-items-center'
              onClick={() => {
                state === "policy-history"
                  ? navigate(-1)
                  : navigate("/admin/customer-policy-view", {
                      state: {
                        customerId:
                          policyScheduleData?.policy_document1.customerId,
                        policyAppNumber:
                          policyScheduleData?.policy_document1.policyAppNumber,
                      },
                    });
              }}
            >
              <span>Continue</span>
              <BsArrowRight />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default PolicySchedule;
